import React  from 'react';
import {connect} from 'react-redux';
import {selectors} from '../../Redux/index';

import PageContent from '../../Components/Helper/PageContent';

const Page = (props) => {

    switch (props.language) {
        case 'de':
            return (
                <PageContent>
                    <h1>API</h1>
                    <h2>XML Format (DB Abrechnungskurse 13 Uhr) alternativ verfügbar unter</h2>
                    <h3>alle Währungen:</h3>
                    <p>https://www.db-markets.com/portal/FxSettlementRates/tt.mm.jjjj<br/>
                        (tt.mm.jjjj z.B. 06.02.2015)</p>

                    <h3>eine Währung:</h3>
                    <p>https://www.db-markets.com/portal/FxSettlementRates/tt.mm.jjjj/ccy<br/>
                        (ccy z.B. USD)</p>

                    <h2>XML Format (DB Abrechnungskurse 18 Uhr) alternativ verfügbar unter</h2>
                    <h3>alle Währungen:</h3>
                    <p>https://www.db-markets.com/portal/FxSettlementRates6/tt.mm.jjjj<br/>
                        (tt.mm.jjjj z.B. 06.02.2015)</p>

                    <h3>eine Währung:</h3>
                    <p>https://www.db-markets.com/portal/FxSettlementRates6/tt.mm.jjjj/ccy<br/>
                        (ccy z.B. USD)</p>
                    <h2>XML Format (EOM Tarife) alternativ verfügbar unter</h2>
                    <p>https://www.db-markets.com/portal/FxRatesME/mm.jjjj<br/>
                        (mm-jjjj e.g. 09.2015)</p>

                     <h2>XML Format (Montly Average Tarife) alternativ verfügbar unter</h2>
                    <p>https://www.db-markets.com/portal/FxRatesMR/mm.jjjj<br/> 
                       (mm-jjjj e.g. 09.2015)</p> 
                       <h2>XML Format (Yearly Average Tarife) alternativ verfügbar unter</h2>
                    <p>https://www.db-markets.com/portal/FxRatesYR/jjjj<br/> 
                       (jjjj e.g. 2015)</p>
                </PageContent>
            );
        default:
            return (
                <PageContent>
                    <h1>API</h1>
                    <h2>XML format (DB Settlement Rates 1 p.m.) available also at</h2>
                    <h3>All Currencies:</h3>
                    <p>https://www.db-markets.com/portal/FxSettlementRates/jjjj-mm-tt<br/>
                        (jjjj-mm-tt e.g. 2015-02-06)</p>

                    <h3>One Currency:</h3>
                    <p>https://www.db-markets.com/portal/FxSettlementRates/jjjj-mm-tt/ccy<br/>
                        (ccy e.g. USD)</p>

                    <h2>XML format (DB Settlement Rates 6 p.m.) available also at</h2>
                    <h3>All Currencies:</h3>
                    <p>https://www.db-markets.com/portal/FxSettlementRates6/jjjj-mm-tt<br/>
                        (jjjj-mm-tt e.g. 2015-02-06)</p>

                    <h3>One Currency:</h3>
                    <p>https://www.db-markets.com/portal/FxSettlementRates6/jjjj-mm-tt/ccy<br/>
                        (ccy e.g. USD)</p>

                    <h2>XML format of EOM Rates also available at</h2>
                    <p>https://www.db-markets.com/portal/FxRatesME/mm-jjjj<br/>
                        (mm-jjjj e.g. 09-2015)</p>

                    <h2>XML format of Montly Average rates also available at</h2>
                    <p>https://www.db-markets.com/portal/FxRatesMR/mm-jjjj<br/>
                        (mm-jjjj e.g. 09-2015)</p>

                    <h2>XML format of Yearly Average rates also available at</h2>
                    <p>https://www.db-markets.com/portal/FxRatesYR/jjjj<br/>
                        (jjjj e.g. 2015)</p>
                </PageContent>
            )
    }


};

const mapStateToProps = (state) => {
    return {
        language: selectors.UI.Locale.getLocale(state)
    };
};

export default connect(mapStateToProps)(Page);
